import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { api } from "../lib/api";
import Nav from "../components/Nav";
import Hero from "../components/Hero";
import EditorialMarquee from "../components/Marquee";
import Services from "../components/Services";
import WhyBrep from "../components/WhyBrep";
import Footer from "../components/Footer";
import SEO from "../components/SEO";
import PageShell from "../components/marketing/PageShell";
import CTAStrip from "../components/marketing/CTAStrip";

export default function Home() {
  const { hash } = useLocation();

  useEffect(() => {
    try {
      if (!sessionStorage.getItem("brep_view_logged")) {
        api.post("/views", { path: "/" }).catch(() => {});
        sessionStorage.setItem("brep_view_logged", "1");
      }
    } catch { /* noop */ }
  }, []);

  useEffect(() => {
    if (hash) {
      const id = hash.replace("#", "");
      setTimeout(() => {
        document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
      }, 120);
    }
  }, [hash]);

  return (
    <PageShell testid="page-home">
      <SEO
        title={null}
        description="BRep — a live fitness marketplace. Connect with qualified coaches for personalised one-off services. Pay per service, no subscription."
        path="/"
      />
      <Nav />
      <Hero />
      <EditorialMarquee />
      <Services />
      <WhyBrep />
      <EditorialMarquee />
      <CTAStrip
        eyebrow="Get Started"
        title="Buy only the help you need."
        subtitle="Browse the service catalogue, download the app, or apply to coach on BRep."
        primary={{ to: "/services", label: "View Services" }}
        secondary={{ to: "/download", label: "Download App" }}
      />
      <Footer />
    </PageShell>
  );
}
